import useAllPricing from "features/subscriptions/datahooks/useAllPricing";

import type {
  AgencySubscription,
  Pricing,
  RentedSubscription,
  Subscription,
  SubscriptionType,
} from "common/types";

export default function usePricingOptions(
  subscriptionType: SubscriptionType,
  currentSubscription: Subscription | AgencySubscription | RentedSubscription,
) {
  const { allPricing } = useAllPricing();

  const pricingOptions = allPricing
    ? allPricing
        .filter(({ id, subscription_type, period, period_unit }) => {
          if (
            currentSubscription?.item_price.period_unit === period_unit &&
            currentSubscription?.item_price.period === period
          ) {
            return currentSubscription.item_price.id === id;
          }
          return subscription_type === subscriptionType;
        })
        .reduce(
          (accumulator, currentItem) => {
            if (currentItem.item_type === "plan") {
              const addon = allPricing.find(
                ({ item_type, period_unit, period, subscription_type }) =>
                  item_type === "addon" &&
                  period_unit === currentItem.period_unit &&
                  period === currentItem.period &&
                  subscription_type === currentItem.subscription_type,
              );
              if (addon) {
                accumulator.push({
                  plan: currentItem,
                  addon,
                });
              }
            }
            return accumulator;
          },
          [] as { addon: Pricing; plan: Pricing }[],
        )
        .filter(
          ({ plan }) =>
            plan.visible || currentSubscription?.item_price.id === plan.id,
        )
        .sort((option1, option2) => {
          const days1 =
            (option1.plan.period_unit === "month" ? 30 : 360) *
            option1.plan.period;
          const days2 =
            (option2.plan.period_unit === "month" ? 30 : 360) *
            option2.plan.period;
          return days1 - days2;
        })
    : [];

  return { pricingOptions };
}
